import { render } from "./MaterialTextarea.vue?vue&type=template&id=2733841a&scoped=true"
import script from "./MaterialTextarea.vue?vue&type=script&lang=js"
export * from "./MaterialTextarea.vue?vue&type=script&lang=js"

import "./MaterialTextarea.vue?vue&type=style&index=0&id=2733841a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2733841a"]])

export default __exports__